<template>
  <div class="professional-expenses">
    <div class="stenci-group stenci-alert text-center">
      <h6 class="stenci-title text-secondary">
        Restrição de serviços no atendimento
      </h6>

      <div class="form-group">
        Caso o profissional <strong class="text-error">não possua</strong>
        restrições de atendimento por serviço, não será necessário adicioná-la a esta lista.
      </div>

      <div class="form-group">
        Ao vincular o profissional a uma ou mais serviços, os atendimentos realizados por ele
        ficarão <strong>restritos</strong> exclusivamente aos serviços vinculados.
      </div>

      <div class="mb-2" v-if="!isNew">
        <button class="btn btn-secondary btn-icon btn-icon-left"
                :disabled="saving || deleting"
                @click="addExpense">
          <fa-icon :icon="['fal', 'plus']" />Adicionar serviços
        </button>
      </div>
      <div class="text-bold text-error" v-else>Para adicionar, primeiro salve o cadastro!</div>
    </div>

    <div class="loading loading-lg" v-if="loading || saving" />

    <template v-else>
      <div class="empty mt-2" v-if="data.items.length === 0">
        <div class="empty-icon">
          <fa-icon :icon="['fal', 'info-circle']" size="2x"/>
        </div>
        <p class="empty-title h5">Lista de serviços</p>
        <p class="empty-subtitle">
          Nenhum serviço adicionado, clique no botão abaixo para adicionar.
        </p>
      </div>
      <table class="table table-hover" v-else>
        <thead>
        <tr>
          <th>#</th>
          <th>Nome do serviço</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in data.items" :key="i">
          <td>{{ i + 1 }}</td>
          <td>{{ item.expense.name }}</td>
          <td class="text-right">
            <button class="btn btn-sm btn-action btn-icon btn-error tooltip"
                    :class="{loading: deleting && idx === i}"
                    :disabled="saving || deleting"
                    data-tooltip="Excluir"
                    @click="removeExpense(item)">
              <fa-icon :icon="['fal', 'times']" />
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </template>

    <find-expense-modal
      v-if="findExpenseModalShow"
      @selected="selectedExpenses"
      @close="findExpenseModalShow = false"
    />
  </div>
</template>

<script>
import FindExpenseModal from '../../expense/components/modals/FindExpenseModal.vue';

export default {
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
    professionalId: {
      type: String,
      required: true,
    },
  },
  components: {
    FindExpenseModal,
  },
  data() {
    return {
      idx: null,
      loading: false,
      saving: false,
      deleting: false,
      findExpenseModalShow: false,
      data: {
        items: [],
        hasMore: false,
        limit: 0,
        offset: 0,
      },
    };
  },
  async mounted() {
    if (!this.isNew) {
      this.init();
    }
  },
  methods: {
    init() {
      this.loadProfessionalExpenses();
    },
    loadProfessionalExpenses() {
      this.loading = true;
      const { professionalId } = this;

      const params = {
        limit: this.data.limit,
        offset: this.data.offset,
      };

      return this.$http
        .get(`/professionals/${professionalId}/expenses`, { params })
        .then(({ data }) => {
          this.data.items = data.items;
        })
        .catch(() => {
          this.$toast.error('Erro ao carregar os dados!');
        }).finally(() => {
          this.loading = false;
        });
    },
    addExpense() {
      this.findExpenseModalShow = true;
    },
    selectedExpenses(expenses) {
      if (this.saving || this.deleting) {
        return null;
      }

      this.saving = true;
      this.findExpenseModalShow = false;

      const savedExpenseIds = this.data.items.map(item => item.id);
      expenses = expenses.filter(item => !savedExpenseIds.includes(item.id));

      if (expenses.length === 0) {
        this.saving = false;
        return null;
      }

      const { professionalId } = this;

      return this.$http
        .post(`/professionals/${professionalId}/expenses`, { expenses })
        .then(() => {
          this.loadProfessionalExpenses();
          this.$toast.success('Serviços adicionados com sucesso!');
        })
        .catch(() => {
          this.$toast.error('Erro ao carregar os dados!');
        }).finally(() => {
          this.saving = false;
        });
    },
    removeExpense(item) {
      if (this.deleting) {
        return;
      }

      this.idx = this.data.items.indexOf(item);
      this.deleting = true;

      const { professionalId } = this;

      this.$http
        .delete(`/professionals/${professionalId}/expenses/${item.expense.id}`)
        .then(() => {
          this.data.items.splice(this.idx, 1);
        })
        .catch(() => {
          this.$toast.error('Erro ao excluir o serviço!');
        })
        .finally(() => {
          this.deleting = false;
        });
    },
  },
};
</script>
